import styled from "styled-components";
import { colors } from "../../theme/colors";

export const StyledSubtitle = styled.p`
  color: ${colors.primary};
  border-radius: 50px;
  background-color: ${colors.secondary};
  display: inline-block;
  padding: 0.5rem 5rem;
  text-align: center;
  font-family: OpenSans;
  font-size: 24px;
`;

export const StyledTopWrapprer = styled.div`
  height: 500px;
  background-color: ${colors.yellow.dark};
  position: absolute;
  width: 100%;
  top: calc(25px - 25px + 200px);
  z-index: -1;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    top: calc(200px + 9vh);
    height: 650px;
    margin: auto;
  }
`;
